export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'thirdParty', label: '所属第三方', minWidth: '50', align: 'left'},
    {prop: 'channel', label: '来源渠道', minWidth: '80', align: 'left'},
    {prop: 'userId', label: '工作微信号', minWidth: '80', align: 'left'},
    {prop: 'userName', label: '使用人', minWidth: '80', align: 'left'},
    {prop: 'corpName', label: '所属主体', minWidth: '80', align: 'left'},
    {prop: 'totalCount', label: '添加人数', minWidth: '60', sortable: true,},
    {prop: 'deletedCount', label: '删微人数', minWidth: '60', sortable: true,},
    {prop: 'repeatCount', label: '重复数量', minWidth: '60', sortable: true, slotName: 'repeatCount'},
    {label: '操作', minWidth: '60', slotName: 'handler'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
